import React from "react";
import Nice from "../../../../assets/svgs/gameplay/Nice";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

function NiceAnimation() {

  return (
    <CommonAnimation>
      <Nice width={getWidth(106)} height={getWidth(40)} />
    </CommonAnimation>
    
  );
}

export default NiceAnimation;
